import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { Link } from "react-router-dom";
import { DatePicker, TimePicker, Select } from "antd";
import dayjs from "dayjs";
import { getExhibitionProgramListMaster_action, insertProgramMaster_action, updateProgramMaster_action, getExhibitionProgramDetailsMaster_action } from "../../../../actions/admin_module_action/delegate_master_action/delegate_program_action"
import { connect } from "react-redux";
import {
    DOC_BASE_URL,
    downloadReport,
    fetchAuthReport,
    NA,
    signatureDocName,
    toastError, bonafideDocName,
    toastSuccess, paymentMasterListActionId,
    BASE_URL
} from "../../../../utils/constants";
import Resizer from "react-image-file-resizer";

class Delegate_ProgramList_AU extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_add: true,
            programID: '',
            name: '',
            location: '',
            mainProgramList: [{
                name: '',
                location: '',
                programs: [
                    {
                        Date: null, Days: '', StartTime: null, EndTime: null, category: [], categoryText: '', ExhProgramDateID: ''
                    }
                ], DocumentName: '',
                DocumentPath: '', DocumentFile: '', DocumentType: '',
            }],

        };
    }

    componentDidMount() {
        const { state } = this.props.location;
        if (this.props.location && this.props.location.state) {
            this.setState({
                programID: this.props.location.state != null && this.props.location.state.programID ? this.props.location.state.programID : '',
                is_add: this.props.location.state != null && this.props.location.state.is_add ? this.props.location.state.is_add : '',
            }, () => {
                this.getExhibitionProgramDetailMaster()
            })
        }
        if (state && state.data) {
            this.setState({
                is_add: false,
                programs: []
            });
        }
    }

    getExhibitionProgramDetailMaster() {
        const { programID, date } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitionProgramDetailsMaster_action(programID)
            .then((data) => {
                if (data.error != 1) {
                    for (var i = 0; i < data.data[1].length; i++) {
                        data.data[1][i].categoryText = ''
                        var arr = []
                        for (var j = 0; j < data.data[2].length; j++) {
                            if (data.data[1][i].ExhProgramDateID == data.data[2][j].ExhProgramDateID) {
                                arr.push(data.data[2][j])
                            }
                        }
                        data.data[1][i].category = arr
                    }
                    var temppath = data.data[0][0].InvitationCard
                    var temparr = temppath != null &&
                        temppath != "" ? temppath.split("/") : []
                    var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                    data.data[0][0].DocumentName = temppath != '' && temppath != null ? tempName : ''
                    // data.data[0][0].DocumentType = ''
                    // data.data[0][0].DocumentFile = ''
                    data.data[0][0].DocumentPath = temppath != '' && temppath != null ? temppath : ''
                    console.log(data.data[0][0], temparr, temppath)
                    // setTimeout(() => {

                    this.setState({
                        mainProgramList: [{
                            name: data.data[0][0].ProgramName,
                            location: data.data[0][0].Location,
                            programs: data.data[1],
                            DocumentName: data.data[0][0].DocumentName,
                            DocumentPath: data.data[0][0].DocumentPath, DocumentFile: '', DocumentType: '',
                        }],
                        // programs: data.data[1]
                    })
                    // }, 100);
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handleSaveprogram() {
        const { is_add, programs, name, programID, location, mainProgramList } = this.state;
        var DateCount = 0
        var MainList = []
        var dateList = []
        var categoryList = []
        var err = false
        mainProgramList.map((item0, i) => {
            item0.RefID = i + 1
            item0.ExhProgramID = programID
            if (item0.name == '' || item0.name == null) {
                toastError("Please enter All Program Name")
                err = true
                return
            }
            if (item0.location.trim() == '' || item0.location == null) {
                toastError("Please enter All Program location")
                err = true
                return
            }
            MainList.push(item0)
            item0.programs.map((item, i2) => {
                item.ProgramRefID = i + 1
                item.RefID = DateCount + 1
                DateCount = DateCount + 1
                item.ExhProgramID = programID
                if (item.Date == '' || item.Date == null) {
                    toastError("Please enter All Date")
                    err = true
                    return
                }
                if (item.StartTime == '' || item.StartTime == null) {
                    toastError("Please enter All Start time")
                    err = true
                    return
                }
                if (item.EndTime == '' || item.EndTime == null) {
                    toastError("Please enter All End time")
                    err = true
                    return
                }
                dateList.push(item)
                if (item.category.length > 0) {
                    item.category.map(item2 => {
                        item2.ExhProgramID = programID
                        item2.ProgramDateRefID = item.RefID
                        categoryList.push(item2)
                    })
                }
            })

        })

        this.setState({ isLoading: true })
        setTimeout(() => {
            if (err) {
            } else {
                if (is_add) {
                    this.props.insertProgramMaster_action(MainList, dateList, categoryList)
                        .then((data) => {
                            if (data.error != 1) {
                                toastSuccess("Program Added Successfully")
                                this.setState({ isLoading: false })
                                setTimeout(() => {
                                    this.props.navigate('/delegateProgramList');
                                }, 2000);
                            }
                            else {
                                this.setState({ isLoading: false })
                                toastError(data.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                } else {
                    this.props.updateProgramMaster_action(MainList, dateList, categoryList)
                        .then((data) => {
                            if (data.error != 1) {
                                toastSuccess("Program Added Successfully")
                                this.setState({ isLoading: false })
                                setTimeout(() => {
                                    this.props.navigate('/delegateProgramList');
                                }, 2000);
                            }
                            else {
                                this.setState({ isLoading: false })
                                toastError(data.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                }
            }
        }, 200);


    }

    onFilePick = async (e, file, i) => {
        e.preventDefault()
        const { mainProgramList, tempFilePath } = this.state
        // console.log("File01010101------", file, key)
        const { } = this.state
        console.log(file, document.getElementById(`file${i}`), tempFilePath)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {

                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        mainProgramList[i].DocumentFile = image
                        mainProgramList[i].DocumentName = file[0]['name'].toString()
                        //     visitorGroupList[i].passportFileErr = ''
                        this.setState({ mainProgramList: mainProgramList })
                        // } else {
                        // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
                        // }

                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        // if (key == 1) {
                        // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                        mainProgramList[i].DocumentFile = image
                        mainProgramList[i].DocumentName = file[0]['name'].toString()
                        this.setState({ mainProgramList: mainProgramList })
                        // } else {
                        // this.setState({ passportFile: image, passportFileErr: "" })
                        // }
                        // this.setState({ passportFile: image, passportFileErr: "" })

                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    // if (sessionStorage.getItem('VisitorTypeID') == 2) {
                    //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                    //     this.setState({ visitorGroupList: visitorGroupList })
                    // } else {
                    mainProgramList[i].DocumentType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                    // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

                    // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                    // }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

                    // if (key == 1) {
                    //     this.setState({ passportFile: "" })
                    //     document.getElementById("passportFile").value = ""
                    // } else if (key == 2) {
                    //     this.setState({ visitorLetterFile: "" })
                    //     document.getElementById("visitorLetter").value = ""
                    // }
                }
            }
        } else {
            //     exhibitDetailsList[i].DocumentType = ''
            //     exhibitDetailsList[i].DocumentFile = ''
            //     exhibitDetailsList[i].DocumentName = ''
            //     this.setState({ exhibitDetailsList: exhibitDetailsList })
        }
    }

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onCrossClick(i) {
        const { mainProgramList } = this.state
        // i = i - 1
        // console.log(isPassportFilePresent, i + 1)
        // if (sessionStorage.getItem('VisitorTypeID') == 1) {
        // console.log('isPassportFilePresent', isPassportFilePresent)
        if (mainProgramList[i].isFilePresent) {
            // const { isOpen3 } = this.state
            // this.setState({ isOpen3: !isOpen3 })
            // exhibitDetailsList[i].DocumentType = ''
            // exhibitDetailsList[i].DocumentFile = ''
            // exhibitDetailsList[i].DocumentName = ''
            // this.setState({ exhibitDetailsList: exhibitDetailsList })
            console.log("condition------------1111111111")
        } else {
            console.log("condition------------2222222222")
            // if (key == 1) {
            // if (mode == 1) {
            //     this.setState({ passportFile: "", isVisaApplied: false })
            // } else {
            mainProgramList[i].DocumentType = ''
            mainProgramList[i].DocumentFile = ''
            mainProgramList[i].DocumentName = ''
            this.setState({ mainProgramList: mainProgramList })
            // document.getElementById(`file${i}`).value = ""
            // }
            // } else if (key == 2) {
            //     this.setState({ visitorLetterFile: "" })
            //     document.getElementById("visitorLetter").value = ""
            // }
        }
    }


    renderNewImage = (img, type) => {
        const { imageBase64 } = this.state;

        if (type == 'pdf') {
            // window.open(img, "_blank")

            const base64 = img;
            const pdfData = atob(base64.split(",")[1]); // decode Base64

            const len = pdfData.length;
            const uintArray = new Uint8Array(new ArrayBuffer(len));
            for (let i = 0; i < len; i++) {
                uintArray[i] = pdfData.charCodeAt(i);
            }

            const blob = new Blob([uintArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            window.open(url, "_blank"); // open in new tab

        } else {
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(
                    `<img src="${img}" style="width:100%;height:auto;" />`
                );
            } else {
                alert("Please allow popups for this website");
            }
        }
    };

    handleAddProgram = () => {
        const { mainProgramList } = this.state;
        const newId = mainProgramList.length > 0 ? Math.max(...mainProgramList.map(p => p.id)) + 1 : 1;
        this.setState({
            mainProgramList: [...mainProgramList, {
                name: '',
                location: '',
                programs: [
                    {
                        Date: null, Days: '', StartTime: null, EndTime: null, category: [], categoryText: '', ExhProgramDateID: ''
                    }
                ], DocumentName: '',
                DocumentPath: '', DocumentFile: '', DocumentType: '',
            }]
        });
    }

    handleRemoveProgram = (index) => {
        const { mainProgramList } = this.state;
        if (mainProgramList.length > 1) {
            const updated = [...mainProgramList];
            updated.splice(index, 1);
            this.setState({ mainProgramList: updated });
        }
    }

    handleChange = (index, field, value) => {
        const { programs } = this.state;
        const updated = [...programs];
        updated[index][field] = value;

        if (field === 'cpDate' || field === 'mDate') {
            const d = new Date(value);
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const dayField = field === 'cpDate' ? 'cpDay' : 'mDay';
            updated[index][dayField] = !isNaN(d) ? days[d.getDay()] : '';
        }
        this.setState({ programs: updated });
    }

    onProgramChange = (index, cpIndex, field, value) => {
        const { mainProgramList } = this.state;
        const updated = [...mainProgramList];
        console.log(value)
        updated[index].programs[cpIndex][field] = value;
        if (field === 'Date') {
            const d = new Date(value);
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            updated[index].programs[cpIndex].Days = !isNaN(d) ? days[d.getDay()] : '';
        }
        this.setState({ mainProgramList: updated });
    }

    handleAddCarParking = (index) => {
        const { mainProgramList } = this.state;
        const updated = [...mainProgramList];
        updated[index].programs.push({
            Date: null, Days: '', StartTime: null, EndTime: null, category: [], categoryText: '', ExhProgramDateID: '',
        });
        this.setState({ programs: updated });
    }

    handleAddCategory = (index, cpIndex) => {
        const { mainProgramList } = this.state;
        const cp = mainProgramList[index].programs[cpIndex];
        console.log(cp)
        if (cp.categoryText && cp.categoryText.trim() !== '') {
            const updated = [...mainProgramList];
            var obj = {
                CategoryName: cp.categoryText.trim(),
                ExhProgramCategoryID: '',
                ExhProgramDateID: cp.ExhProgramDateID
            }
            updated[index].programs[cpIndex].category.push(obj);
            updated[index].programs[cpIndex].categoryText = '';
            this.setState({ mainProgramList: updated });
        }
    }

    handleRemoveCategory = (index, cpIndex, catIndex) => {
        console.log(index, cpIndex, catIndex)
        const updated = [...this.state.mainProgramList];
        updated[index].programs[cpIndex].category.splice(catIndex, 1);
        this.setState({ mainProgramList: updated });
    }

    handleRemoveDate = (index, cpIndex) => {
        const updated = [...this.state.mainProgramList];
        updated[index].programs.splice(cpIndex, 1);
        this.setState({ mainProgramList: updated });
    }

    // handleSave = () => {
    //     // Dummy save logic, just redirect back for now
    //     this.props.navigate('/delegateProgramList');
    // }

    render() {
        const { is_add, programs, name, location, mainProgramList } = this.state;
        console.log('pr', mainProgramList)
        return (
            <>
                <ToastContainer />
                <HeaderWithLogo />
                <div className="app-content with-dr-container com-height" style={{ marginTop: '5rem', backgroundColor: '#f4f6f9' }}>
                    <AdminDrawer />
                    <div className="row" style={{ marginLeft: '0.3rem' }}>
                        <div className="step-name">
                            <p>{is_add ? 'Add' : 'Edit'} Program</p>
                        </div>
                    </div>

                    <div className="m-3">
                        {mainProgramList.length > 0 && mainProgramList.map((program, index) => (
                            <div className="card shadow-sm mb-4" style={{ border: '1px solid #dee2e6', borderTop: '2px solid #008774', borderRadius: '4px' }}>
                                <div className="card-header bg-white d-flex justify-content-between align-items-center py-2" style={{ borderBottom: 'none' }}>
                                    <h6 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '15px' }}>{is_add ? '' : program.name}</h6>
                                    {(mainProgramList.length > 1 && is_add) && (
                                        <button type="button" className="btn btn-link text-danger p-0" onClick={() => this.handleRemoveProgram(index)}>
                                            <i className="fa fa-trash-o" style={{ fontSize: '16px' }}></i>
                                        </button>
                                    )}
                                </div>
                                <div className="card-body pt-1 pb-3">
                                    <div className="row ">
                                        <div className="col-md-12 mb-3">
                                            <label style={{ fontSize: '12px' }}>Program Name <span className="text-red">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control w-100"
                                                placeholder="Enter venue or program name"
                                                value={program.name}
                                                onChange={(e) => {
                                                    var updated = [...mainProgramList]
                                                    updated[index].name = e.target.value
                                                    this.setState({ mainProgramList: updated })
                                                }}
                                            />
                                        </div>
                                        {/* Car Parking Section */}
                                        <div className="col-md-12 mt-2">
                                            {/* <h6 className="section-title fw-semibold mb-2">Car Parking</h6> */}
                                        </div>
                                        <div className="col-md-12">
                                            {program.programs.map((cp, cpIdx) => (
                                                <div className={`row border rounded-2 mb-2 m-0 py-2 ${cpIdx < program.programs.length - 1 ? 'bg-light' : ''}`} key={cpIdx}>
                                                    <div className="col-md-2">
                                                        <label style={{ fontSize: '12px' }}>Date <span className="text-red">*</span></label>
                                                        <DatePicker
                                                            minDate={dayjs()}
                                                            className="form-control w-100"
                                                            value={cp.Date ? dayjs(cp.Date) : null}
                                                            format="YYYY-MM-DD"
                                                            onChange={(date, dateString) => this.onProgramChange(index, cpIdx, 'Date', dateString)}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label style={{ fontSize: '12px' }}>Day</label>
                                                        <input
                                                            type="text"
                                                            className="form-control w-100"
                                                            value={cp.Days}
                                                            placeholder="Day"
                                                            readOnly
                                                            disabled
                                                            style={{ backgroundColor: '#f4f6f9' }}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label style={{ fontSize: '12px' }}>Start <span className="text-red">*</span></label>
                                                        <TimePicker
                                                            className="form-control w-100"
                                                            value={cp.StartTime ? dayjs(cp.StartTime, 'HH:mm') : null}
                                                            format="HH:mm"
                                                            disabledTime={() => {
                                                                // Check if MaxTime has a value
                                                                if (!cp.EndTime) {
                                                                    return {};
                                                                }

                                                                const max = dayjs(cp.EndTime, 'HH:mm');
                                                                const maxHour = max.hour();
                                                                const maxMinute = max.minute();

                                                                return {
                                                                    disabledHours: () =>
                                                                        Array.from(
                                                                            { length: 23 - maxHour },
                                                                            (_, i) => maxHour + 1 + i
                                                                        ),

                                                                    disabledMinutes: (selectedHour) => {
                                                                        if (selectedHour === maxHour) {
                                                                            return Array.from(
                                                                                { length: 60 - maxMinute - 1 },
                                                                                (_, i) => maxMinute + 1 + i
                                                                            );
                                                                        }

                                                                        return [];
                                                                    }
                                                                };
                                                            }}
                                                            onChange={(time, timeString) => this.onProgramChange(index, cpIdx, 'StartTime', timeString)}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label style={{ fontSize: '12px' }}>End <span className="text-red">*</span></label>
                                                        <TimePicker
                                                            className="form-control w-100"
                                                            value={cp.EndTime ? dayjs(cp.EndTime, 'HH:mm') : null}
                                                            format="HH:mm"
                                                            disabledTime={() => {
                                                                if (!cp.StartTime) {
                                                                    return {};
                                                                }

                                                                const min = dayjs(cp.StartTime, 'HH:mm');
                                                                const minHour = min.hour();
                                                                const minMinute = min.minute();


                                                                return {
                                                                    disabledHours: () =>
                                                                        Array.from({ length: minHour }, (_, i) => i),

                                                                    disabledMinutes: (selectedHour) => {
                                                                        if (cp.StartTime != '' && cp.StartTime != null && cp.StartTime != undefined) {
                                                                            if (selectedHour === minHour) {
                                                                                return Array.from({ length: minMinute }, (_, i) => i);
                                                                            }
                                                                        }

                                                                        return [];
                                                                    }
                                                                };
                                                            }}
                                                            onChange={(time, timeString) => this.onProgramChange(index, cpIdx, 'EndTime', timeString)}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label style={{ fontSize: '12px' }}>Category type</label>
                                                        <div className="d-flex align-items-start">
                                                            <div className="flex-grow-1">
                                                                <div className="input-group">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Add Category"
                                                                        value={cp.categoryText || ''}
                                                                        onChange={(e) => this.onProgramChange(index, cpIdx, 'categoryText', e.target.value)}
                                                                        onKeyPress={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                e.preventDefault();
                                                                                this.handleAddCategory(index, cpIdx);
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-secondary px-3"
                                                                        style={{ border: '1px solid #ced4da', color: '#333' }}
                                                                        onClick={() => this.handleAddCategory(index, cpIdx)}
                                                                    >
                                                                        Add
                                                                    </button>
                                                                </div>
                                                                {cp.category && cp.category.length > 0 && (
                                                                    <div className="mt-2" style={{ textAlign: 'left' }}>
                                                                        {cp.category.map((cat, catIdx) => (
                                                                            <span key={catIdx} className="badge bg-light text-dark border me-1 mb-1 fw-normal" style={{ fontSize: '11px' }}>
                                                                                {cat.CategoryName} <i className="fa fa-times text-danger ms-1" style={{ cursor: 'pointer' }}
                                                                                    onClick={() => this.handleRemoveCategory(index, cpIdx, catIdx)}
                                                                                ></i>
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {program.programs.length > 1 && (
                                                                <button type="button" className="btn btn-link text-danger p-0 ms-2 mt-2" onClick={() => this.handleRemoveDate(index, cpIdx)}>
                                                                    <i className="fa fa-trash-o" style={{ fontSize: '16px' }}></i>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="row mt-2 mb-2">
                                                <div className="col-md-12 text-end">
                                                    <button type="button" className="btn btn-aqua btn-sm py-2"
                                                        onClick={() => this.handleAddCarParking(index)}
                                                    >
                                                        Add More
                                                    </button>
                                                </div>
                                            </div>
                                        </div>


                                        {/* Meal Section Hidden */}
                                        <div className="col-md-12">
                                            <label style={{ fontSize: '12px' }}>Location <span className="text-red">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control w-100"
                                                placeholder="e.g. Hall A, Main Stage"
                                                value={program.location}
                                                onChange={(e) => {
                                                    var updated = [...mainProgramList]
                                                    updated[index].location = e.target.value
                                                    this.setState({ mainProgramList: updated })
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-12" style={{ marginTop: '2rem' }}>
                                            <label style={{ fontSize: '12px' }}>Invitation Card</label>
                                            {
                                                // program.DocDeleted == false || 
                                                program.DocumentName != '' ?
                                                    <div style={{
                                                        justifyContent: 'left',
                                                        display: 'flex',
                                                        // justifyContent: 'start', alignItems: 'start', padding: '0'
                                                        // alignItems: 'center',
                                                        // marginTop: '10px'
                                                    }}>
                                                        <div style={{
                                                            // margin: '2rem 1rem',
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            display: 'inline-flex',
                                                            // justifyContent: 'start', alignItems: 'start', padding: '0'
                                                            // alignItems: 'center',
                                                            // marginTop: '10px'
                                                        }}>
                                                            {/* {console.log(this.state.isSSifile)} */}
                                                            {program.DocumentFile == '' ? <a
                                                                href={program.DocumentPath}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <span style={{ marginRight: '10px' }}
                                                                >{program.DocumentName}</span>
                                                            </a> : <span onClick={() => this.renderNewImage(program.DocumentFile, program.DocumentType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                            >{program.DocumentName}</span>}
                                                            <i className={`fa fa-times text-danger img-can`}
                                                                onClick={(e) => this.onCrossClick(index)}
                                                            ></i>
                                                        </div>
                                                    </div>
                                                    : <div className="upload-container mt-1" style={{
                                                        justifyContent: 'start', alignItems: 'start', padding: '0'
                                                    }}>
                                                        <input
                                                            type="file"

                                                            id={`file${index}`}
                                                            ref={this.fileInputRef}
                                                            name={`file${index}`}
                                                            class="image-upload"
                                                            accept=".jpg,.jpeg,.png,.pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files, index)}
                                                            hidden
                                                        />

                                                        <button type="button" class="choose-file-btn"
                                                            style={{ background: '#3dbca7' }} id="chooseFileBtn" onClick={() => document.getElementById(`file${index}`).click()}>
                                                            Choose File
                                                        </button>
                                                    </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div style={{ height: '60px' }}></div>
                    </div>
                </div>

                <div className="bg-white border-top p-3 py-2 d-flex justify-content-end align-items-center" style={{ position: 'fixed', bottom: 0, left: '218px', right: 0, zIndex: 1000 }}>
                    <div className="text-right">
                        {is_add && (
                            <button type="button" className="btn btn-aqua mx-1 rounded-1"
                                style={{ border: '1px solid #008774', color: '#008774', backgroundColor: '#fdfdfd' }}
                                onClick={this.handleAddProgram}
                            >
                                Add Another Program
                            </button>
                        )}
                        <button type="button" className="btn btn-aqua px-4 mx-1 rounded-1" onClick={() => this.handleSaveprogram()}>
                            {is_add ? 'Save' : 'Update'}
                        </button>
                        <Link to="/delegateProgramList">
                            <button type="button" className="btn btn-gray px-4 mx-1 rounded-1">
                                Back
                            </button>
                        </Link>
                    </div>
                </div>
            </>
        );
    }
}
export default withRouter(
    connect(null, {
        getExhibitionProgramListMaster_action, getExhibitionProgramDetailsMaster_action, insertProgramMaster_action, updateProgramMaster_action
    })(Delegate_ProgramList_AU)
);